import axios from 'axios';

function authHeaders() {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
}

export const boothQueueAPI = {
  // Join a booth queue
  async joinQueue(queueData) {
    const res = await axios.post('/api/booth-queue/join', queueData, { 
      headers: authHeaders() 
    });
    return res.data;
  },

  // Leave a booth queue. 404/already-gone is treated as success so Exit
  // still clears local state when the server already dropped the entry.
  async leaveQueue(boothId, { leaveAll } = {}) {
    try {
      const res = await axios.post('/api/booth-queue/leave', { boothId, leaveAll: !!leaveAll }, {
        headers: authHeaders()
      });
      return res.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: true, message: 'Not in queue' };
      }
      throw error;
    }
  },

  // Get current queue status for a booth
  async getQueueStatus(boothId) {
    const res = await axios.get(`/api/booth-queue/status/${boothId}`, { 
      headers: authHeaders() 
    });
    return res.data;
  },

  // Get queue for a specific booth (recruiter view), optionally scoped to one event
  async getBoothQueue(boothId, eventId) {
    const res = await axios.get(`/api/booth-queue/booth/${boothId}`, { 
      headers: authHeaders(),
      params: eventId ? { eventId } : undefined
    });
    return res.data;
  },

  // Invite a job seeker to meeting (recruiter action)
  async inviteToMeeting(queueId, meetingData) {
    const res = await axios.post(`/api/booth-queue/invite/${queueId}`, meetingData, { 
      headers: authHeaders() 
    });
    return res.data;
  },

  // Send message to recruiter while in queue
  async sendMessage(messageData) {
    const res = await axios.post('/api/booth-queue/message', messageData, { 
      headers: authHeaders() 
    });
    return res.data;
  },

  // Get messages for a queue entry (recruiter view)
  async getQueueMessages(queueId) {
    const res = await axios.get(`/api/booth-queue/messages/${queueId}`, { 
      headers: authHeaders() 
    });
    return res.data;
  },

  // Update queue serving number (recruiter action)
  async updateServingNumber(boothId, servingNumber) {
    const res = await axios.patch(`/api/booth-queue/serving/${boothId}`, 
      { servingNumber }, 
      { headers: authHeaders() }
    );
    return res.data;
  },

  // Remove job seeker from queue (recruiter action)
  async removeFromQueue(queueId) {
    const res = await axios.delete(`/api/booth-queue/remove/${queueId}`, { 
      headers: authHeaders() 
    });
    return res.data;
  },

  // Leave queue with message (audio/video)
  async leaveWithMessage(messageData) {
    const res = await axios.post('/api/booth-queue/leave-with-message', messageData, { 
      headers: authHeaders() 
    });
    return res.data;
  },

  // Get messages for current user's queue entry
  async getMessages(queueId) {
    const res = await axios.get(`/api/booth-queue/messages/${queueId}`, { 
      headers: authHeaders() 
    });
    return res.data;
  },

  // Send message from recruiter to job seeker
  async sendMessageToJobSeeker(queueId, content) {
    const res = await axios.post(`/api/booth-queue/message-to-jobseeker/${queueId}`, 
      { content }, 
      { headers: authHeaders() }
    );
    return res.data;
  },

  // Broadcast message to all active job seekers in the booth queue
  async broadcastMessage(boothId, content, eventId) {
    const res = await axios.post('/api/booth-queue/broadcast-message',
      { boothId, content, eventId: eventId || undefined },
      { headers: authHeaders() }
    );
    return res.data;
  }
};
